import type { MapperContext } from '../../types'

/**
 * Tri-state helper for optional metadata fields: `field: clearable(value, ctx)`.
 *
 * Native `editPost` treats an omitted metadata sub-field as "preserve the
 * stored value", so an absent value must be omitted on create but sent as an
 * explicit `null` on edit to clear what was previously saved:
 *
 * - `operation: 'create'` → `value ?? undefined` (field omitted)
 * - `operation: 'edit'` → `value ?? null` (stored field cleared)
 *
 * Present values — including falsy ones like `false`, `0`, and `''` — pass
 * through unchanged.
 */
export function clearable<T>(
  value: T | null | undefined,
  ctx: Pick<MapperContext, 'operation'>,
): T | null | undefined {
  return value ?? (ctx.operation === 'edit' ? null : undefined)
}
